class ServerRequest {
  API_URL_AUTH = 'https://api.movie-aidea.com/api/auth';
  API_URL_GENERATE_MOVIE = 'https://api.movie-aidea.com/api/get-data-from-tmdb';
  API_SHARE_CARD_LINK = 'https://api.movie-aidea.com/api/share';
  API_GET_SHARE_CARD_LINK = 'https://api.movie-aidea.com/api/shared';
  API_URL_GET_FAVORITES = 'https://api.movie-aidea.com/api/get-favorites';
  API_URL_ADD_FAVORITE = 'https://api.movie-aidea.com/api/add-favorite';
  API_URL_REMOVE_FAVORITE = 'https://api.movie-aidea.com/api/remove-favorite';
  API_URL_GET_ALL_MOVIE_NEWS = 'https://api.movie-aidea.com/api/get-all-movie-news';


  getHeaders() {
    return {
      "Content-Type": "application/json",
    };
  };


  async authenticateUserData(number) {
    const response = await fetch(this.API_URL_AUTH, {
      method: "POST",
      body: JSON.stringify(
        {
          "user_phone": number,
          "geo": "GR",
          "aggregator": "Techlab"
        }),
      headers: this.getHeaders(),
    })
    return response;
  };


  async createShareLinkData(movieData, userHash) {
    let data = {
      "movieData": movieData,
      "userHash": userHash,
    }
    const response = await fetch(this.API_SHARE_CARD_LINK, {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(data),
    })
    return response;
  };


  async getSharedCard(token) {
    const response = await fetch(`${this.API_GET_SHARE_CARD_LINK}/${token}`, {
      method: "GET",
      headers: this.getHeaders(),
    })
    return response;
  };


  async addFavoriteMovie(userHash, movieData) {
    const response = await fetch(this.API_URL_ADD_FAVORITE, {
      method: "POST",
      body: JSON.stringify({
        user_hash: userHash,
        movie_data: movieData,
        liked: true,
      }),
      headers: this.getHeaders(),
    });
    return response;
  }


  async removeFavoriteMovie(userHash, movieId) {
    const response = await fetch(this.API_URL_REMOVE_FAVORITE, {
      method: "POST",
      body: JSON.stringify({
        user_hash: userHash,
        movie_id: movieId,
      }),
      headers: this.getHeaders(),
    });
    return response;
  }


  async getFavoriteMovies(userHash) {
    const response = await fetch(`${this.API_URL_GET_FAVORITES}?user_hash=${userHash}`, {
      method: "GET",
      headers: this.getHeaders(),
    });
    return response;
  }


  async getAllMovieNews() {
    const response = await fetch(`${this.API_URL_GET_ALL_MOVIE_NEWS}`, {
      method: "POST",
      headers: this.getHeaders(),
      body: JSON.stringify(
        {
          "lang": 'gr'
        }),
    });
    return response;
  }


  async createMovieData(movieData, userHash, userPhone) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => {
      controller.abort(); // Скасувати запит через 120 секунд
    }, 100000); // 100000 мс = 100 секунд

    const data = {
      lang: 'gr',
      movieData: movieData,
      userHash: userHash,
      userPhone: userPhone,
    };

    try {
      const response = await fetch(this.API_URL_GENERATE_MOVIE, {
        method: "POST",
        body: JSON.stringify(data),
        headers: this.getHeaders(),
        signal: controller.signal, // передаємо контролер
      });

      clearTimeout(timeoutId); // якщо запит завершено — зупиняємо таймер

      return response;
    } catch (error) {
      clearTimeout(timeoutId); // зупинити таймер у випадку помилки

      if (error.name === "AbortError") {
        console.error("Request timed out after 100 seconds");
        throw new Error("Timeout: Server took too long to respond.");
      } else {
        console.error("Fetch error:", error);
        throw error;
      }
    }
  }
}

export default new ServerRequest();